import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ResellersService } from '@generated/tcea/services/resellers.service';
import { ResellerCreateRequest } from '@generated/tcea/models/reseller-create-request';
import { ResellerMasterdata } from '@generated/tcea/models/reseller-masterdata';
import { ResellerUpdateRequest } from '@generated/tcea/models/reseller-update-request';

@Injectable({
  providedIn: 'root',
})
export class ResellerService {
  constructor(private resellersApi: ResellersService) {}

  createReseller(payload: ResellerCreateRequest, brandId: string): Observable<ResellerMasterdata> {
    return this.resellersApi.postReseller({
      body: payload,
      'Active-Tenant-Identifier': brandId,
    });
  }

  getResellers(): Observable<ResellerMasterdata[]> {
    return this.resellersApi
      .getResellers()
      .pipe(map((response) => response._embedded?.resellers || []));
  }

  getReseller(resellerId: string): Observable<ResellerMasterdata> {
    return this.resellersApi.getReseller({ resellerId: resellerId });
  }

  updateReseller(
    resellerId: string,
    payload: ResellerUpdateRequest,
    brandId: string,
  ): Observable<ResellerMasterdata> {
    return this.resellersApi.putReseller({
      resellerId: resellerId,
      body: payload,
      'Active-Tenant-Identifier': brandId,
    });
  }

  // Wrapper for GET /resellers/users
  searchResellerUsers(params: {
    firstName?: string;
    lastName?: string;
    external?: boolean;
    email?: string;
    phoneNumber?: string;
    status?: 'active' | 'invited' | 'disabled';
    roleId?: string;
    resellerId?: string;
    size?: number;
    start?: string;
    sortField?: string;
    sortDir?: 'asc' | 'desc';
  }): Observable<any> {
    return this.resellersApi.getResellersUsersList(params);
  }
}
